import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useAppContext } from '../components/AppContext';
import config from '../config';
import {
    Button, 
    CircularProgress, 
    Typography, 
    Box,
    Paper
} from '@mui/material';

const SincroInversions = () => {
  const [processId, setProcessId] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [loadingProcess, setLoadingProcess] = useState(false);
  const { ctxUser } = useAppContext();
  const jwtToken = ctxUser?.fdvToken?.jwtToken || '';
  const { userapp } = useParams();

  const startProcess = async () => {
    try {
      setLoadingProcess(true);
      setProcessId(null);
      const response = await axios.post(`${config.apiBaseUrl}/v1/inversions/sync/${userapp}`, {}, {
        headers: { Authorization: `${jwtToken}`}
      });
      setProcessId(response.data);
      setProcessing(true);
    } catch (error) {
      console.error("Error al iniciar el proceso de sincronización de inversiones", error);
      setLoadingProcess(false);
      setProcessing(false);
    }
  };

  useEffect(() => {
    let interval;
    if (processId && processing) {
      interval = setInterval(async () => {
        try {
          const response = await axios.get(`${config.apiBaseUrl}/v1/inversions/sync/isinproces/${processId}`, {
            headers: { Authorization: `${jwtToken}`}
          });
          const isProcessing = response.data === true;
          setProcessing(isProcessing);
          if (!isProcessing) {
            clearInterval(interval);
            setLoadingProcess(false);
          }
        } catch (error) {
          console.error("Error al consultar el estado del proceso", error);
          clearInterval(interval);
          setLoadingProcess(false);
        }
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [processId, processing, jwtToken]);

  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ padding: 3, marginBottom: 4 }}>
        <Typography variant="h5" gutterBottom>Procés Sincronització Inversions</Typography>
        {processId &&
          <Box sx={{ marginBottom: 2 }}>
            <Typography>ID del procés: {processId}</Typography>
            <Typography>Estat: { processing ? 'EN CURS' : 'FINALITZAT' }</Typography>
            {loadingProcess && <CircularProgress size={24} sx={{ marginLeft: 2, verticalAlign: 'middle' }} />}
          </Box>
        }
        { !processing && !loadingProcess &&
          <Button variant="contained" onClick={startProcess} disabled={loadingProcess}>
            Iniciar Procés
          </Button>
        }
        { loadingProcess && !processId && <Typography sx={{ fontStyle: 'italic', marginTop: 1 }}>Iniciant procés...</Typography>}
      </Paper>
    </Box>
  );
};

export default SincroInversions;
